/* 
页面曝光埋点 
*/
import HTTP from '@/request/index'
export default {
  inserted: function (el, binding) {
    let eventk =
      (el.attributes['data-page-buried'] &&
        el.attributes['data-page-buried'].value) ||
      ''
    let eventv =
      (el.attributes['data-eventv'] && el.attributes['data-eventv'].value) || ''
    let list = eventk.split(',')
    list.map((item) => {
      if (item) {
        HTTP.bindH5UMA(item, eventv)
      }
    })
  }
}
